
import { HashMap } from './utils.js'

export const gTranslation = new HashMap()

gTranslation.put('fr', new HashMap())
gTranslation.fr.put('Yes', 'Oui')
gTranslation.fr.put('No', 'Non')
gTranslation.fr.put('Configuration', 'Configuration')
gTranslation.fr.put('Describ your problem.<br>Thanks<br><br>', 'D&eacute;crivez le plus pr&eacute;cis&eacute;ment possible, comment vous avez obtenu ce probl&egrave;me.<br>Merci de votre aide.<br><br>')
gTranslation.fr.put('Bug report', 'Rapport de bogue')
gTranslation.fr.put('Version', 'Version')
gTranslation.fr.put('Use the <i>Lucterios</i> framework', 'Utilise le cadre d\'application <i>Lucterios</i>')
gTranslation.fr.put('Server', 'Serveur')
gTranslation.fr.put('Cordova client', 'Client Cordova')
gTranslation.fr.put('Tool of customize management on GPL license', 'Outil de gestion personnalis&eacute; sous licence GPL')
gTranslation.fr.put('ask support', 'Support...')
gTranslation.fr.put('About...', 'A propos...')
gTranslation.fr.put('Logon', 'Connexion')
gTranslation.fr.put('Logoff', 'D&eacute;connexion')
gTranslation.fr.put('Refresh', 'Rafraichir')
gTranslation.fr.put('Error', 'Erreur')
gTranslation.fr.put('Warning', 'Avertissement')
gTranslation.fr.put('Information', 'Information')
gTranslation.fr.put('Call-stack', 'Pile d\'appel')
gTranslation.fr.put('Extra', 'Extra')
gTranslation.fr.put('Requette', 'Requ&ecirc;te')
gTranslation.fr.put('Reponse', 'R&eacute;ponse')
gTranslation.fr.put('Sent to support', 'Envoyer au support')
gTranslation.fr.put('Page #', 'Page N°')
gTranslation.fr.put('Select one line before!', 'S&eacute;lectionnez une ligne avant !')
gTranslation.fr.put('Select only one line!', 'Ne s&eacute;lectionnez qu\'une ligne !')
gTranslation.fr.put('Upload impossible{[br/]}The file must be less than %sMo ', 'T&eacute;l&eacute;chargement impossible{[br/]}Le fichier doit faire moins de %sMo ')
gTranslation.fr.put('Loading...', 'Chargement...')
gTranslation.fr.put('Save as...', 'Enregistrer sous...')
gTranslation.fr.put('Browser', 'Navigateur')
gTranslation.fr.put('Connection', 'Connexion')
gTranslation.fr.put('Ok', 'Ok')
gTranslation.fr.put('Cancel', 'Annuler')
gTranslation.fr.put('Username or password wrong!', 'Alias ou Mot de passe incorrect!')
gTranslation.fr.put('Email or password wrong!', 'Courriel ou Mot de passe incorrect!')
gTranslation.fr.put('Please, identify you', 'Veuillez vous identifier')
gTranslation.fr.put('Connection', 'Connexion')
gTranslation.fr.put('Username', 'Alias')
gTranslation.fr.put('Email', 'Courriel')
gTranslation.fr.put('Password', 'Mot de passe')
gTranslation.fr.put('Close', 'Fermer')
gTranslation.fr.put('This field is needed!', 'Ce champ est obligatoire!')
gTranslation.fr.put('The field \'%s\' is needed!', 'Le champ \'%s\' est obligatoire!')
gTranslation.fr.put('Invalid format!', 'Format invalide!')
gTranslation.fr.put('Lost connection!', 'Connexion perdue!')
gTranslation.fr.put('Captcha wrong!', 'Mauvais Captcha!')
gTranslation.fr.put('Password too short!', 'Mot de passe trop court!')
gTranslation.fr.put('Password too simple!', 'Mot de passe trop simple!')
gTranslation.fr.put('Help', 'Aide')
gTranslation.fr.put('Info', 'Info')
gTranslation.fr.put('This Web browser don\'t support this feature!\nUse Firefox, Chrome, Safari or Edge.', 'Ce navigateur Web ne support pas cette fonctionnalité!{[br/]}Utilisez Firefox, Chrome, Safari ou Edge.')
gTranslation.fr.put('Thank you for supporting our work.', 'Merci de soutenir notre travail.')
gTranslation.fr.put('More...', 'Plus...')
gTranslation.fr.put('Loading', 'Chargement en cours')
gTranslation.fr.put('NoRows', 'Aucune ligne à afficher.')
gTranslation.fr.put('FirstPage', 'Première page')
gTranslation.fr.put('PrevPage', 'Page précédente')
gTranslation.fr.put('NextPage', 'Page suivante')
gTranslation.fr.put('LastPage', 'Dernière page')
gTranslation.fr.put('Refresh', 'Actualiser')
gTranslation.fr.put('Rpp', 'Résultats par page: %s')
gTranslation.fr.put('Display', 'Voir %s à %s sur %s résultats.')
gTranslation.fr.put('ShowNB', '%s résultats.')
gTranslation.fr.put('Drag one file to this zone ...', 'Glisser un fichier dans cette zone ...')
gTranslation.fr.put('%s on %s', '\'%s\' sur \'%s\'')
gTranslation.fr.put('Device client', 'Dispositif client')
gTranslation.fr.put('File', 'Fichier')
gTranslation.fr.put('Picture', 'Image')
gTranslation.fr.put('Take picture', 'Capturer une image')
gTranslation.fr.put('Browser does not support camera for this address :(', 'Ce navigateur ne supporte pas les webcams pour cette adresse :(')
gTranslation.fr.put('name', 'nom')
gTranslation.fr.put('address', 'adresse')
gTranslation.fr.put('current', 'courant')
gTranslation.fr.put('add', 'ajouter')
gTranslation.fr.put('delete', 'supprimer')
gTranslation.fr.put('Add new server address', 'Ajouter une nouvelle adresse de serveur')
gTranslation.fr.put('Manage server addresses', 'Gérer des adresses de serveurs')
gTranslation.fr.put('Add server', 'Ajouter un serveur')
gTranslation.fr.put('Servers', 'Les serveurs')
gTranslation.fr.put('Client obselete', 'Client obsolète <br/> Effectuer une mise à jour')
gTranslation.fr.put('Date invalid!', 'Date invalide !')
gTranslation.fr.put('Only administrators can access!', 'Seuls les administrateurs peuvent accéder !')

gTranslation.put('en', new HashMap())
gTranslation.en.put('Yes', 'Yes')
gTranslation.en.put('No', 'No')
gTranslation.en.put('Configuration', 'Configuration')
gTranslation.en.put('Describ your problem.<br>Thanks<br><br>', 'Describ your problem.<br>Thanks<br><br>')
gTranslation.en.put('Bug report', 'Bug report')
gTranslation.en.put('Version', 'Version')
gTranslation.en.put('Use the <i>Lucterios</i> framework', 'Use the <i>Lucterios</i> framework')
gTranslation.en.put('Server', 'Server')
gTranslation.en.put('Cordova client', 'Cordova client')
gTranslation.en.put('Tool of customize management on GPL license', 'Tool of customize management on GPL license')
gTranslation.en.put('ask support', 'Ask support')
gTranslation.en.put('About...', 'About...')
gTranslation.en.put('Logon', 'Logon')
gTranslation.en.put('Logoff', 'Logoff')
gTranslation.en.put('Refresh', 'Refresh')
gTranslation.en.put('Error', 'Error')
gTranslation.en.put('Warning', 'Warning')
gTranslation.en.put('Information', 'Information')
gTranslation.en.put('Call-stack', 'Call-stack')
gTranslation.en.put('Extra', 'Extra')
gTranslation.en.put('Requette', 'Request')
gTranslation.en.put('Reponse', 'Response')
gTranslation.en.put('Sent to support', 'Sent to support')
gTranslation.en.put('Page #', 'Page #')
gTranslation.en.put('Select one line before!', 'Select one line before!')
gTranslation.en.put('Select only one line!', 'Select only one line!')
gTranslation.en.put('Upload impossible{[br/]}The file must be less than %sMo ', 'Upload impossible{[br/]}The file must be less than %sMo ')
gTranslation.en.put('Loading...', 'Loading...')
gTranslation.en.put('Save as...', 'Save as...')
gTranslation.en.put('Browser', 'Browser')
gTranslation.en.put('Connection', 'Connection')
gTranslation.en.put('Ok', 'Ok')
gTranslation.en.put('Cancel', 'Cancel')
gTranslation.en.put('Username or password wrong!', 'Wrong user-name or password !')
gTranslation.en.put('Email or password wrong!', 'Wrong email or password !')
gTranslation.en.put('Please, identify you', 'Please, identify')
gTranslation.en.put('Connection', 'Connection')
gTranslation.en.put('Username', 'User-name')
gTranslation.en.put('Email', 'Email')
gTranslation.en.put('Password', 'Password')
gTranslation.en.put('Close', 'Close')
gTranslation.en.put('This field is needed!', 'This field is needed!')
gTranslation.en.put('The field \'%s\' is needed!', 'The field \'%s\' is needed!')
gTranslation.en.put('Invalid format!', 'Invalid format!')
gTranslation.en.put('Lost connection!', 'Lost connection!')
gTranslation.en.put('Captcha wrong!', 'Captcha wrong!')
gTranslation.en.put('Password too short!', 'Password too short!')
gTranslation.en.put('Password too simple!', 'Password too simple!')
gTranslation.en.put('Help', 'Help')
gTranslation.en.put('Info', 'Info')
gTranslation.en.put('This Web browser don\'t support this feature!\nUse Firefox, Chrome, Safari or Edge.', 'This Web browser don\'t support this feature!{[br/]}Use Firefox, Chrome, Safari or Edge.')
gTranslation.en.put('Thank you for supporting our work.', 'Thank you for supporting our work.')
gTranslation.en.put('More...', 'More...')
gTranslation.en.put('Loading', 'Loading')
gTranslation.en.put('NoRows', 'No rows to display.')
gTranslation.en.put('FirstPage', 'First page')
gTranslation.en.put('PrevPage', 'Previous page')
gTranslation.en.put('NextPage', 'Next page')
gTranslation.en.put('LastPage', 'Last page')
gTranslation.en.put('Refresh', 'Refresh')
gTranslation.en.put('Rpp', 'Records per page: %s')
gTranslation.en.put('Display', 'Displaying %s to %s of %s items.')
gTranslation.en.put('ShowNB', '%s items.')
gTranslation.en.put('Drag one file to this zone ...', 'Drag one file to this zone ...')
gTranslation.en.put('%s on %s', '\'%s\' on \'%s\'')
gTranslation.en.put('Device client', 'Device client')
gTranslation.en.put('File', 'File')
gTranslation.en.put('Picture', 'Picture')
gTranslation.en.put('Take picture', 'Take picture')
gTranslation.en.put('Browser does not support camera for this address :(', 'Browser does not support camera for this address :(')
gTranslation.en.put('name', 'name')
gTranslation.en.put('address', 'address')
gTranslation.en.put('current', 'current')
gTranslation.en.put('add', 'add')
gTranslation.en.put('delete', 'delete')
gTranslation.en.put('Add new server address', 'Add new server address')
gTranslation.en.put('Manage server addresses', 'Manage server addresses')
gTranslation.en.put('Add server', 'Add server')
gTranslation.en.put('Servers', 'Servers')
gTranslation.en.put('Client obselete', 'Obsolete client <br/> Perform an update')
gTranslation.en.put('Date invalid!', 'Date invalid!')
gTranslation.en.put('Only administrators can access!', 'Only administrators can access!')



// WEBPACK FOOTER //
// ./src/language.js